<template>
    <div class="container mb-3" data-aos="fade-up">
        Trucks
    </div>
  </template>
  
  <script>    
  </script>
  
  <style scoped>
  </style>
  